(ns com.theplantscape.plant-web.components.tailwind.forms.register-user-form
  (:require
   [com.theplantscape.plant-web.components.forms.core :refer [remove-atom-hm! update-atom-hm]]
   [com.theplantscape.web-ui.tailwind.ensemble :refer [form]]
   [com.theplantscape.web-ui.tailwind.form.elements.input
    :refer [ui-form-input ui-form-password-input ui-form-password-confirm-input]]
   [reagent.core :as r]))

(defn register-new-user-form [title values cfg]
  (let [form-state (r/atom {:disabled false
                            :mode :login})
        on-webauth-create (fn [e]
                            (.preventDefault e)
                            ((:on-webauth cfg) values))
        on-submit (fn [e]
                    (.preventDefault e)
                    (swap! form-state assoc :disabled true)
                    ((:on-submit cfg) form-state))]
    (fn [title values cfg]
      [:div.min-h-screen.bg-gray-100.flex.flex-col.justify-center.sm:py-12
       (when (:errors @values)
         (into [:div] (map (fn [error] [:p.bg-white (:msg error)]) (:errors @values))))
       [:div.p-10.xs:p-0.mx-auto.md:w-full.md:max-w-md
        [:div.flex
         (when (-> @form-state :disabled)
           [:svg.animate-spin.-ml-1.mr-3.h-6.w-6.text-black
            {:xmlns "http://www.w3.org/2000/svg" :fill "none" :viewBox "0 0 24 24"}
            [:circle.opacity-25 {:cx "12" :cy "12" :r "10" :stroke "#000000" :stroke-width "4"}]
            [:path.opacity-75 {:fill "#000000" :d "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"}]])
         [:h1.font-bold.text-center.text-2xl.mb-5 title]]
        [:div.bg-white.shadow.w-full.rounded-lg.divide-y.divide-gray-200
         [:div.px-5.py-7
          (into [:div] (mapv (fn [error] [:p.bg-white (:msg error)]) (:form-validation @values)))
          [form
           {:on-submit on-submit}
           [:<>

            [ui-form-input
             (r/cursor values [:values :user|email])
             {:label "E-Mail"
              :tooltop "E-Mail"
              :name "user|email"
              :placeholder "name@example.com"
              :store-fn (:on-change cfg)}]

            [ui-form-input
             (r/cursor values [:values :user|display-name])
             {:label "Displayed name"
              :tooltip "Displayed name"
              :name "user|display-name"
              :placeholder "Displayed name"
              :store-fn (:on-change cfg)}]

            #_[:button.transition.duration-200.bg-blue-500.hover:bg-blue-600.focus:bg-blue-700.focus:shadow-sm.focus:ring-4.focus:ring-blue-500.focus:ring-opacity-50.text-white.w-full.py-2.5.rounded-lg.text-sm.shadow-sm.hover:shadow-md.font-semibold.text-center.inline-block
               {:on-click on-webauth-create} "Sign up using Webauth"]

            (when (nil? (-> @values :values :user|public-key))
              [ui-form-password-confirm-input #_ui-form-password-input
               (r/cursor values [:values :user|password])
               {:name "user|password"
                :label "Password"
                :store-fn (fn set-public-key-value-reset-password [e]
                            (remove-atom-hm! values [:values :user|public-key])
                            ((:on-change cfg) e))}])

           ;[:label.font-semibold.text-sm.text-gray-600.pb-1.block "Password"]
            #_[:input.border.rounded-lg.px-3.py-2.mt-1.mb-5.text-sm.w-full
               {:type "password" :value (-> @form-state :values :password) :name "password" :on-change (:on-change cfg)}]

            [:input.transition.duration-200.bg-blue-500.hover:bg-blue-600.focus:bg-blue-700.focus:shadow-sm.focus:ring-4.focus:ring-blue-500.focus:ring-opacity-50.text-white.w-full.py-2.5.rounded-lg.text-sm.shadow-sm.hover:shadow-md.font-semibold.text-center.inline-block
             {:type "submit"
              :disabled (-> @form-state :disabled)
              :value "Register account"}]]]]

         [:div.py-5
          [:div.grid.grid-cols-2.gap-1
           [:div.text-center.sm:text-right.whitespace-nowrap]]]]
        [:div.py-5 [:div.grid.grid-cols-2.gap-1]]]])))
